export default __webpack_public_path__ + "static/media/india.7f3542e8.jpg";